import { SelectField } from '#app/components/form/select-field.tsx'
import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type Option = {
	readonly value: string
	readonly label: string
}

type Props = {
	readonly resources: SectionResources
	readonly secureTransferMethod: string
	readonly drillCadence: string
	readonly secureTransferOptions: ReadonlyArray<Option>
	readonly drillCadenceOptions: ReadonlyArray<Option>
	readonly secureTransferErrors: ReadonlyArray<string>
	readonly drillCadenceErrors: ReadonlyArray<string>
	readonly onSecureTransferChange: (value: string) => void
	readonly onDrillCadenceChange: (value: string) => void
}

export function SecureRecordTransferSection({
	resources,
	secureTransferMethod,
	drillCadence,
	secureTransferOptions,
	drillCadenceOptions,
	secureTransferErrors,
	drillCadenceErrors,
	onSecureTransferChange,
	onDrillCadenceChange,
}: Props) {
	return (
		<Section
			title="Secure record transfer"
			description="Pick the method you rely on to securely hand records to regulators."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
		>
			<SelectField
				labelProps={{
					children: 'How do you securely transfer requested records?',
				}}
				selectProps={{
					name: 'secureTransferMethod',
					value: secureTransferMethod,
					onChange: (event) => onSecureTransferChange(event.target.value),
				}}
				options={secureTransferOptions}
				errors={
					secureTransferErrors.length > 0
						? [...secureTransferErrors]
						: undefined
				}
			/>
			<SelectField
				labelProps={{
					children: 'How often do you rehearse pulling record packages?',
				}}
				selectProps={{
					name: 'drillCadence',
					value: drillCadence,
					onChange: (event) => onDrillCadenceChange(event.target.value),
				}}
				options={drillCadenceOptions}
				errors={
					drillCadenceErrors.length > 0 ? [...drillCadenceErrors] : undefined
				}
			/>
		</Section>
	)
}
